import { useEffect, useState, useContext, useCallback } from "react";
import { IoMdNotifications } from "react-icons/io";
import { formatDistanceToNow, format } from "date-fns";
import { SlOptions } from "react-icons/sl";
import MenueBar from "./Modlas/MenueBar";
import CardSymbol from "./Modlas/CardSymbol";
import Currency from "../../services/Currency";
import Advertisement from "../../services/Advertisement";
import SearchToggle from "./Modlas/SearchToggle";
import FilterToggle from "./Modlas/FilterToggle";
import SelectorToggle from "./Modlas/SelectorToggle";
import AdverCard from "./Modlas/AdverCard";
import Chart from "./component/CurrencyChart";
import React from "react";
import { SafeAreaContext } from "../../App";
import { useSelector } from "react-redux";
import { useLiveCurrency } from "../../hooks/useLiveCurrency";
import { useOutletContext } from "react-router-dom";

export default function Body() {
  const token = useSelector((state) => state.login.token);

  const { setSafeAreaColor } = useContext(SafeAreaContext);

  useEffect(() => {
    setSafeAreaColor({ background: "#FFFFFF" });
  }, []);

  //API
  const [currency, setCurrency] = useState([]);
  const [adver, setAdver] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");

  //last seen
  const [lastVisitTime, setLastVisitTime] = useState(null);
  const [displayTime, setDisplayTime] = useState("");

  //Menu bar
  const [showModal, setShowModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [showCalender, setShowCalender] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(false);

  // searching Modal
  const [openSearchToggle, setOpenSearchToggle] = useState(false);
  const [showSearchToggle, setShowSearchToggle] = useState(false);
  const [searchCurrency, setSearchCurrency] = useState(null);
  const [debouncedSearchMine, setDebouncedSearchMine] = useState(null);

  //filter modal
  const [openFilterToggle, setOpenFilterToggle] = useState(false);
  const [showFilterToggle, setShowFilterToggle] = useState(false);
  const filterValues = ["all", "currency", "stocks", "Commodities", "Forex"];

  //selector modal
  const [openSelectorToggle, setOpenSelectorToggle] = useState(false);
  const [showSelectorToggle, setShowSelectorToggle] = useState(false);

  // Chart State
  const [openChart, setOpenChart] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState(null);

  //filter for all currencies
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [fetchCurrencyLoading, setFetchCurrencyLoading] = useState(false);
  const [filter, setFilter] = useState("all");
  const [searchAllSymbols, setSearchAllSymbols] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState(null);

  const [currencyMeta, setCurrencyMeta] = useState({});


  const { setIsOpen } = useOutletContext();


  async function getCurrencyMeta() {
    try {
      const res = await Currency.getAll({});
      const list = res?.data?.data ?? [];
      const map = {};
      list.forEach((item) => {
        map[item.symbol] = { image: item.image, name: item.name };
      });
      setCurrencyMeta(map);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getCurrencyMeta();
  }, []);

  const enrichedCurrency = (currency ?? []).map((c) => ({
    ...c,
    image: currencyMeta[c.symbol]?.image ?? c.image,
    name: currencyMeta[c.symbol]?.name ?? c.name,
  }));

  const groupedCard = [];
  const currencyLength = enrichedCurrency?.length ?? 0;
  const maxGroups = Math.ceil(currencyLength / 2);
  for (let i = 0; i < maxGroups; i++) {
    const pair = enrichedCurrency?.slice(i * 2, i * 2 + 2);
    const value = adver?.[i] ?? "N/A";
    groupedCard.push({ pair: pair.length ? pair : ["N/A"], value });
  }

  const symbolList = enrichedCurrency?.map((c) => c.symbol) ?? [];

  const Flag = useSelector((state) => state.loading.global);

  const handleLiveUpdate = useCallback((data) => {
    setCurrency((prev) =>
      prev.map((c) => {
        if (c.symbol !== data.symbol) return c;

        return {
          ...c,
          volume: data.price ?? data.volume ?? c.volume,
          open:
            data.changePercent != null
              ? data.changePercent * 100
              : data.open != null
                ? data.open
                : c.open,
          high: data.high ?? c.high,
          low: data.low ?? c.low,
        };
      }),
    );
  }, []);

  const closeChart = () => {
    setOpenChart(false);
    setTimeout(() => setCurrencySymbol(null), 350);
  };

  function clickOnManueBarButton(e) {
    setShowModal((prev) => !prev);
    e.stopPropagation();
    if (isClosing) {
      setTimeout(() => {
        setIsClosing((prev) => !prev);
        // for calender manue
        setCalendarOpen(false);
        setShowCalender(false);
      }, 300);
    } else {
      setIsClosing((prev) => !prev);
    }
  }

  function outSideClick() {
    setShowModal(false);
    setShowCalender(false);
    setTimeout(() => {
      setIsClosing(false);
      setCalendarOpen(false);
    }, 300);
  }

  function clickOnCalenderManue() {
    setShowCalender((prev) => !prev);

    if (calendarOpen) {
      setTimeout(() => {
        setCalendarOpen((prev) => !prev);
      }, 300);
    } else {
      setCalendarOpen((prev) => !prev);
    }
  }

  //chart//////////////////////
  function clickOnCurrencyChart(e, s) {
    if (e?.stopPropagation) {
      e.stopPropagation();
    }
    setCurrencySymbol(s);
    setOpenChart(true);
  }

  async function getMyCurrencies() {
    const params = {
      ...(debouncedSearchMine !== "" && { search: debouncedSearchMine }),
      ...(activeFilter !== "all" && { type: activeFilter }),
    };
    try {
      const res = await Currency.getMyCurrency(params);
      setCurrency(res?.data?.data);
    } catch (err) {
      if (err?.response?.status === 404) {
        setCurrency([]);
      }
      console.log(err);
    }
  }

  async function getAllCurrencies() {
    const params = {
      search: debouncedSearch,
      ...(filter !== "all" && { type: filter }),
    };

    setFetchCurrencyLoading(true);

    try {
      const res = await Currency.getAll(params);
      const list = res?.data?.data ?? [];
      // saved (active) symbols first; Array.sort is stable so the
      // backend order is kept inside each group
      const sorted = [...list].sort(
        (a, b) => Number(!!b.isSaved) - Number(!!a.isSaved)
      );
      setAllCurrencies(sorted);
    } catch (err) {
      if (err?.response?.status === 404) {
        setAllCurrencies([]);
      }
    } finally {
      setFetchCurrencyLoading(false);
    }
  }

  async function getAllAdvertisement() {
    try {
      const res = await Advertisement.getAll();
      setAdver(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchAllSymbols);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchAllSymbols]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchMine(searchCurrency);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchCurrency]);

  useEffect(() => {
    if (showFilterToggle) {
      setOpenSearchToggle(false);
      setShowSearchToggle(false);
    }
  }, [showFilterToggle]);

  useEffect(() => {
    if (showSearchToggle) {
      setOpenFilterToggle(false);
      setShowFilterToggle(false);
    }
  }, [showSearchToggle]);

  useEffect(() => {
    const lastVisitString = localStorage.getItem("lastVisit");
    const lastVisitDate = lastVisitString ? new Date(lastVisitString) : null;
    setLastVisitTime(lastVisitDate);
    localStorage.setItem("lastVisit", new Date().toISOString());
  }, []);

  useEffect(() => {
    if (!lastVisitTime) {
      setDisplayTime("Just now");
      return;
    }

    function updateTime() {
      const now = new Date();
      const diff = now - lastVisitTime;

      if (diff < 5000) {
        setDisplayTime("just now");
      } else if (diff < 60000) {
        const seconds = Math.floor(diff / 1000);
        setDisplayTime(`${seconds} seconds ago`);
      } else if (diff < 24 * 60 * 60 * 1000) {
        setDisplayTime(formatDistanceToNow(lastVisitTime, { addSuffix: true }));
      } else if (diff < 48 * 60 * 60 * 1000) {
        setDisplayTime("yesterday");
      } else if (diff < 30 * 24 * 60 * 60 * 1000) {
        const days = Math.floor(diff / (24 * 60 * 60 * 1000));
        setDisplayTime(`${days} days ago`);
      } else if (diff < 365 * 24 * 60 * 60 * 1000) {
        const months = Math.floor(diff / (30 * 24 * 60 * 60 * 1000));
        setDisplayTime(`${months} months ago`);
      } else {
        setDisplayTime(format(lastVisitTime, "dd/MM/yyyy"));
      }
    }

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, [lastVisitTime, token]);

  useEffect(() => {
    if (openSelectorToggle) {
      getAllCurrencies();
    }
  }, [openSelectorToggle, debouncedSearch, filter]);

  useEffect(() => {
    getAllAdvertisement();
  }, []);

  useEffect(() => {
    getMyCurrencies();
  }, [debouncedSearchMine, activeFilter]);

  useEffect(() => {
    if (openChart || openSearchToggle) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [openChart, openSearchToggle]);

  useLiveCurrency(symbolList, handleLiveUpdate);

  const headerAnimation = (
    <div className="flex justify-center items-center gap-2">
      <div className="nav-icon text-2xl flex items-end justify-center w-8 h-8 space-x-0.5 relative">
        {[
          { height: "60%", delay: "-0.4s", bg: "from-blue-800 to-blue-400" },
          { height: "90%", delay: "-0.2s", bg: "from-blue-700 to-sky-400" },
          { height: "75%", delay: "0s", bg: "from-blue-900 to-blue-600" },
        ].map((bar, idx) => (
          <div
            key={idx}
            className={`w-[3px] rounded-sm animate-candle bg-gradient-to-t ${bar.bg}`}
            style={{
              height: bar.height,
              animationDelay: bar.delay,
            }}
          />
        ))}
      </div>
      <div className="flex felx-col justify-center items-center mt-2">
        <h1 className="text-2xl font-bold text-text-primary text-center">
          Markets
        </h1>
      </div>
    </div>
  );

  return (
    <>
      <div
        className="flex min-h-screen flex-col bg-light   text-text-primary "
        onClick={outSideClick}
      >
        {/* items of menueBar */}
        <SearchToggle
          setSearchCurrency={setSearchCurrency}
          searchCurrency={searchCurrency}
          openSearchToggle={openSearchToggle}
          showSearchToggle={showSearchToggle}
          setOpenSearchToggle={setOpenSearchToggle}
          setShowSearchToggle={setShowSearchToggle}
        />
        <FilterToggle
          openFilterToggle={openFilterToggle}
          showFilterToggle={showFilterToggle}
          filters={filterValues}
          setActiveFilter={setActiveFilter}
          activeFilter={activeFilter}
        />
        <SelectorToggle
          isOpen={openSelectorToggle}
          setShowSelectorToggle={setShowSelectorToggle}
          showSelectorToggle={showSelectorToggle}
          onClose={setOpenSelectorToggle}
          allSymbols={allCurrencies}
          loading={fetchCurrencyLoading}
          search={searchAllSymbols}
          setSearch={setSearchAllSymbols}
          filter={filter}
          setFilter={setFilter}
          filterValues={filterValues}
          onSaved={getMyCurrencies}
        />

        {/* Chart Modal */}
        <Chart
          openChart={openChart}
          symbol={currencySymbol}
          onClose={closeChart}
        />

        {/* Header */}
        <header className="bg-white h-[120px] px-4 py-4 shadow-lg fixed top-0 z-20 w-full flex flex-col justify-between">
          {/* header of header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">{headerAnimation}</div>

            <button onClick={() => setIsOpen(true)} className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors">
              <IoMdNotifications className="size-5 text-orange-500"></IoMdNotifications>
            </button>
          </div>
          {/* header of header */}

          {/* footer of header */}
          <section className="flex-shrink-0 bg-white  w-full">
            <div className="flex  items-center  justify-between text-xs w-full">
              <div className="flex  items-center space-x-2">
                <div className="flex items-center gap-1">
                  <div className="h-2 w-2 animate-pulse mb-[1px] rounded-full bg-green-400 " />
                  <span className="font-medium text-[12px] text-[#808080]">
                    Live
                  </span>
                </div>

                <div className="h-3 w-px bg-gray-300 " />
                <span className=" flex flex-row gap-2 ">
                  <p className="inline text-[#808080] text-[12px]">Last:</p>
                  <p className="font-bold text-[12px] ">
                    {displayTime ? displayTime : "Just now"}
                  </p>
                </span>
              </div>

              <div className="relative">
                <button
                  onClick={clickOnManueBarButton}
                  className={`flex h-8 w-8 items-center justify-center rounded-lg bg-gray-50 hover:bg-gray-100 transition-all duration-200  ${showModal && "rotate-90"} `}
                >
                  <SlOptions className="text-[#878888] md:size-4"></SlOptions>
                </button>

                <MenueBar
                  isClosing={isClosing}
                  showModal={showModal}
                  calendarOpen={calendarOpen}
                  showCalender={showCalender}
                  clickOnCalenderManue={clickOnCalenderManue}
                  setOpenSearchToggle={setOpenSearchToggle}
                  openSearchToggle={openSearchToggle}
                  setShowSearchToggle={setShowSearchToggle}
                  clickOnManueBarButton={clickOnManueBarButton}
                  openFilterToggle={openFilterToggle}
                  setOpenFilterToggle={setOpenFilterToggle}
                  setShowFilterToggle={setShowFilterToggle}
                  openSelectorToggle={openSelectorToggle}
                  setOpenSelectorToggle={setOpenSelectorToggle}
                  setShowSelectorToggle={setShowSelectorToggle}
                />
              </div>
            </div>
          </section>
        </header>

        {/* Server Time */}

        <main className="pb-20 flex-1">
          {/* Symbols Grid */}
        <section
    className={`
        ${showSearchToggle ? "translate-y-[75px]" : ""}
        ${showFilterToggle ? "translate-y-[95px]" : ""}
        relative transition-transform duration-300
        flex-grow px-4 pt-[130px]
    `}
>
    <div className="pb-4">
              <div className="grid  grid-cols-2  gap-4 px-1 border-1 border-[#E5E7EB] ">
                {!Flag &&
                  Array.isArray(groupedCard) &&
                  groupedCard?.map((it, index) => (
                    <React.Fragment key={`group-${index}`}>
                      {it?.pair?.length && it?.pair?.length === 1 ? (
                        it.pair[0] !== "N/A" && (
                          <CardSymbol
                            onClick={(e) =>
                              clickOnCurrencyChart(e, it?.pair[0])
                            }
                            s={it?.pair[0]}
                          />
                        )
                      ) : (
                        <>
                          <CardSymbol
                            onClick={(e) =>
                              clickOnCurrencyChart(e, it?.pair[0])
                            }
                            s={it?.pair[0]}
                          />
                          <CardSymbol
                            onClick={(e) =>
                              clickOnCurrencyChart(e, it?.pair[1])
                            }
                            s={it?.pair[1]}
                          />
                        </>
                      )}

                      {it.value !== "N/A" && (
                        <AdverCard s={it.value} indx={index}></AdverCard>
                      )}
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}